import Api from "../helpers/api";

export const vratDataZDvojkliku = async (lng, lat) => {
  try {
    const response = await Api.get(`/api/v1/smartmap/click/${lat}/${lng}`);
    return response || false;
  } catch (error) {
    errorLog(error);
  }
};
